import { useContext, createContext, useState, useEffect} from "react";
import { useNavigate } from "react-router";
import api from './Services';

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem("token") || "");
  const navigate = useNavigate();



  useEffect(() => {
    refreshToken()   //Do a silent refresh onLoad
 }, []);

const refreshToken = () => {

    return api.post(`/?rest_route=/simple-jwt-login/v1/auth/refresh&JWT=${localStorage.getItem('token')}`)
        .then(response => {
            // publish user to subscribers and start timer to refresh token
            setToken(response.data.data.jwt);
            localStorage.setItem("token", response.data.data.jwt);
            startRefreshTokenTimer();
            return response;
        })
        .catch((err) => {
            console.log(err.message);
            if (err.status === 400) {
              navigate('/login')
            }
        });
}


let refreshTokenTimeout;

const startRefreshTokenTimer = () => {
    // parse json object from base64 encoded jwt token
    const jwtToken = JSON.parse(atob(localStorage.getItem("token").split('.')[1]));

    // set a timeout to refresh the token a minute before it expires
    const expires = new Date(jwtToken.exp * 1000);
    const timeout = expires.getTime() - Date.now() - (60 * 1000);
    refreshTokenTimeout = setTimeout(refreshToken, timeout);
}

const stopRefreshTokenTimer = () => {
    clearTimeout(refreshTokenTimeout);
}





  const loginAction = async (data) => {
    try {
      const response = await api.post("?rest_route=/simple-jwt-login/v1/auth", data);
      const res = await response.data;
      if (res) {
        setToken(res.data.jwt);
        localStorage.setItem("token", res.data.jwt);
        startRefreshTokenTimer()
        navigate("/");
        return;
      }
      throw new Error(res.message);
    } catch (err) {
      console.error(err);
    }

  };
  const logOut = () => {
    setToken("");
    localStorage.removeItem("token");
    stopRefreshTokenTimer()
    navigate("/login");
  };
  return (
    <AuthContext.Provider value={{ token, loginAction, logOut }}>
      {children}
    </AuthContext.Provider>
  );

};

export default AuthProvider;

export const useAuth = () => {
  return useContext(AuthContext);
};